import { type Control, Controller, type FieldValues, type Path } from "react-hook-form";
import RenderHooks from "render-hooks";
import { useDebouncedEffect } from "../../hooks";

/** Props Interface */
interface DataTableInputProps<T extends FieldValues>
	extends React.InputHTMLAttributes<HTMLInputElement> {
	control: Control<T>;
	name: Path<T>;
}

export function DataTableInput<T extends FieldValues>({
	control,
	name,
	...props
}: DataTableInputProps<T>) {
	/** Constants */
	const isNumberType = props.type === "number";

	/** Render */
	return (
		<Controller
			control={control}
			name={name}
			render={({ field }) => {
				return (
					<RenderHooks hooks={{ useDebouncedEffect } as const}>
						{({ useDebouncedEffect, useState }) => {
							const [currentValue, setCurrentValue] = useState<any>(field.value);

							useDebouncedEffect(
								() => {
									field.onChange(currentValue);
								},
								[currentValue],
								250,
							);

							/** Render */
							return (
								<input
									className="input rounded-none border-none absolute inset-0"
									value={currentValue}
									onChange={(e) => {
										props.type === "number"
											? setCurrentValue(Number(e.target.value))
											: setCurrentValue(e.target.value);
									}}
									onFocus={(e) => {
										if (!isNumberType) return;
										e.target.select();
									}}
									onScroll={props.type === "number" ? (e) => e.currentTarget.blur() : undefined}
									onWheel={props.type === "number" ? (e) => e.currentTarget.blur() : undefined}
									{...props}
								/>
							);
						}}
					</RenderHooks>
				);
			}}
		/>
	);
}
